import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { ReactComponent as DecimalFormatIcon } from 'common/Prose/Toolbar/components/Format/components/ToggleListPane/NumberedListButton/decimalFormat.svg'
import { ReactComponent as DecimalLetterNonFlattenedFormatIcon } from 'common/Prose/Toolbar/components/Format/components/ToggleListPane/NumberedListButton/decimalLetterNonFlattenedFormat.svg'
import { ReactComponent as DecimalNonFlattenedFormatIcon } from 'common/Prose/Toolbar/components/Format/components/ToggleListPane/NumberedListButton/decimalNonFlattenedFormat.svg'
import { ReactComponent as DecimalParenthesesFormatIcon } from 'common/Prose/Toolbar/components/Format/components/ToggleListPane/NumberedListButton/decimalParenthesesFormat.svg'
import { ReactComponent as UpperLatinFormatIcon } from 'common/Prose/Toolbar/components/Format/components/ToggleListPane/NumberedListButton/upperLatinFormat.svg'
import { ReactComponent as UpperRomanFormatIcon } from 'common/Prose/Toolbar/components/Format/components/ToggleListPane/NumberedListButton/upperRomanFormat.svg'
import { useNumberedListMarkerToggle } from 'common/Prose/Toolbar/hooks/useNumberedListMarkerToggle'
import { useNumberedListToggle } from 'common/Prose/Toolbar/hooks/useNumberedListToggle'
import { observer } from 'mobx-react-lite'
import { SoftButton } from '../Buttons/Button'
import Styles from './NumberedListDropdown.module.scss'
import { SimpleDropdown } from '../SimpleDropdown/SimpleDropdown'
import { IconName, ToolbarIcon } from 'common/Prose/Toolbar/ToolbarIcon'

export const NumberedListDropdown = observer(function NumberedListDropdown() {
  const view = useEditorView()
  const { active, handleClick } = useNumberedListToggle(view)

  return (
    <SimpleDropdown
      active={active}
      hasChevron={false}
      clickAction={handleClick}
      tooltip={{ label: 'Numbered list' }}
      label="Toggle numbered list"
    >
      <ToolbarIcon name={IconName.ListNumbers} />
      <NumberedListButtons />
    </SimpleDropdown>
  )
})

const NumberedListDecimal = observer(function NumberedListDecimal() {
  const { active, handleClick } = useNumberedListMarkerToggle('decimal')
  return (
    <NumberedListButton active={active} onClick={handleClick} label="Toggle decimal format">
      <DecimalFormatIcon />
    </NumberedListButton>
  )
})

const NumberedListDecimalParentheses = observer(function NumberedListDecimalParentheses() {
  const { active, handleClick } = useNumberedListMarkerToggle('decimalParentheses')
  return (
    <NumberedListButton active={active} onClick={handleClick} label="Toggle decimal parentheses format">
      <DecimalParenthesesFormatIcon />
    </NumberedListButton>
  )
})

const NumberedListDecimalNonFlattened = observer(function NumberedListDecimalNonFlattened() {
  const { active, handleClick } = useNumberedListMarkerToggle('decimalNonFlattened')
  return (
    <NumberedListButton active={active} onClick={handleClick} label="Toggle decimal non-flattened format">
      <DecimalNonFlattenedFormatIcon />
    </NumberedListButton>
  )
})

const NumberedListUpperLatin = observer(function NumberedListUpperLatin() {
  const { active, handleClick } = useNumberedListMarkerToggle('upperLatin')
  return (
    <NumberedListButton active={active} onClick={handleClick} label="Toggle upper latin format">
      <UpperLatinFormatIcon />
    </NumberedListButton>
  )
})

const NumberedListUpperRoman = observer(function NumberedListUpperRoman() {
  const { active, handleClick } = useNumberedListMarkerToggle('upperRoman')
  return (
    <NumberedListButton active={active} onClick={handleClick} label="Toggle upper roman format">
      <UpperRomanFormatIcon />
    </NumberedListButton>
  )
})

const NumberedListDecimalLetterNonFlattened = observer(function NumberedListDecimalLetterNonFlattened() {
  const { active, handleClick } = useNumberedListMarkerToggle('decimalLetterNonFlattened')
  return (
    <NumberedListButton active={active} onClick={handleClick} label="Toggle decimal letter non-flattened format">
      <DecimalLetterNonFlattenedFormatIcon />
    </NumberedListButton>
  )
})

export const NumberedListButtons = () => (
  <>
    <div className={Styles.olTypesDropdown}>
      <NumberedListDecimal />
      <NumberedListDecimalParentheses />
      <NumberedListDecimalNonFlattened />
    </div>
    <div className={Styles.olTypesDropdown}>
      <NumberedListUpperLatin />
      <NumberedListUpperRoman />
      <NumberedListDecimalLetterNonFlattened />
    </div>
  </>
)

const NumberedListButton = observer(function NumberedListButton({
  active,
  onClick,
  children,
  label,
}: {
  active: boolean
  onClick: () => void
  children: React.ReactNode
  label: string
}) {
  return (
    <SoftButton active={active} onClick={onClick} aria-label={label}>
      {children}
    </SoftButton>
  )
})
